import * as React from 'react'
import * as R from 'ramda'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import IconButton from 'material-ui/IconButton'
import AppBar from 'material-ui/AppBar'
import {indexedMap} from '../../Data/ArrayHelper'
import {
    EditablePriceDefinitionRow,
    ProductCalculationDetailsState
} from './ProductCalculationDetailsState'
import {ProductCalculationDetailsAction} from './ProductCalculationDetailsActions'
import Card from 'material-ui/Card/Card'
import {ProductCalculationAutoSuggestionSelect} from './AutoSuggestions/ProductCalculationAutoSuggestionSelect'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Table from 'material-ui/Table/Table'
import TableHeader from 'material-ui/Table/TableHeader'
import TableRow from 'material-ui/Table/TableRow'
import TableHeaderColumn from 'material-ui/Table/TableHeaderColumn'
import TableBody from 'material-ui/Table/TableBody'
import TableRowColumn from 'material-ui/Table/TableRowColumn'
import {EditableFloatingActionButtons} from '../../View/EditableFloatingActionButtons'
import Delete from 'material-ui/svg-icons/action/delete'
import Undo from 'material-ui/svg-icons/content/undo'
import Add from 'material-ui/svg-icons/content/add'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import {errorMessage} from '../../Data/FormValidation'
import {ProductCalculationCreateMessageModal} from './ProductCalculationCreateMessageModal'
import {formatPrice} from '../../Data/NumberHelper'
import {Customer} from '../../Entities/Customer'
import injectSheet from 'react-jss'

interface Props {
    readonly state: ProductCalculationDetailsState
    readonly dispatch: (action: ProductCalculationDetailsAction) => void
}

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    productCalculationWrapper: {
        overflowY: 'scroll',
        flex: '1'
    },
    row: {
        padding: '32px',
        boxSizing: 'border-box'
    }
}
export const ProductCalculationDetailsView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => {
            const disabled = (state.editable.type !== 'Pending')
            const createNewSuggestion = {
                id: 0,
                text: 'New',
                translation: 'Neuen Eintrag erstellen...'
            }
            return (
                <div className={classes.root}>
                    <ProductCalculationCreateMessageModal
                        state={state}
                        dispatch={dispatch}
                    />
                    <EditableFloatingActionButtons
                        editable={state.editable}
                        onEdit={() => dispatch({
                            type: 'EditProductCalculation',
                        })}
                        onSave={() => dispatch({
                            type: 'SaveProductCalculation',
                        })}
                        onDiscard={() => dispatch({
                            type: 'DiscardProductCalculation',
                        })}
                    />
                    <div className="navigation">
                        <AppBar
                            title="Anfragenübersicht"
                            className="navigation__bar"
                            iconElementLeft={
                                <IconButton
                                    onTouchTap={() =>
                                        dispatch({
                                            type: 'MenuButtonClicked',
                                        })}
                                >
                                    <NavigationMenu/>
                                </IconButton>}
                        />
                    </div>
                    <div
                        className={classes.productCalculationWrapper}
                    >
                        <div className={`row ${classes.row}`}>
                            <div className="column">
                                <Card
                                    className="tab__form-card"
                                >
                                    <h4>Produktkalkulationsattribute</h4>
                                    <ProductCalculationAutoSuggestionSelect
                                        disabled={disabled}
                                        dispatch={dispatch}
                                        keyType={'type'}
                                        label={'Typ'}
                                        stateValue={state.typeSearch}
                                        stateSuggestions={[
                                            ...state.typeSuggestions,
                                            createNewSuggestion
                                        ]}
                                    />

                                    <ProductCalculationAutoSuggestionSelect
                                        disabled={disabled}
                                        dispatch={dispatch}
                                        keyType={'format'}
                                        label={'Format'}
                                        stateValue={state.formatSearch}
                                        stateSuggestions={[
                                            ...state.formatSuggestions,
                                            createNewSuggestion
                                        ]}
                                    />

                                    <ProductCalculationAutoSuggestionSelect
                                        disabled={disabled}
                                        dispatch={dispatch}
                                        keyType={'coverage'}
                                        label={'Umfang'}
                                        stateValue={state.coverageSearch}
                                        stateSuggestions={[
                                            ...state.coverageSuggestions,
                                            createNewSuggestion
                                        ]}
                                    />

                                    <ProductCalculationAutoSuggestionSelect
                                        disabled={disabled}
                                        dispatch={dispatch}
                                        keyType={'print'}
                                        label={'Druck'}
                                        stateValue={state.printSearch}
                                        stateSuggestions={[
                                            ...state.printSuggestions,
                                            createNewSuggestion
                                        ]}
                                    />

                                    <ProductCalculationAutoSuggestionSelect
                                        disabled={disabled}
                                        dispatch={dispatch}
                                        keyType={'paper'}
                                        label={'Papier'}
                                        stateValue={state.paperSearch}
                                        stateSuggestions={[
                                            ...state.paperSuggestions,
                                            createNewSuggestion
                                        ]}
                                    />

                                    <ProductCalculationAutoSuggestionSelect
                                        disabled={disabled}
                                        dispatch={dispatch}
                                        keyType={'processing'}
                                        label={'Verarbeitung'}
                                        stateValue={state.processingSearch}
                                        stateSuggestions={[
                                            ...state.processingSuggestions,
                                            createNewSuggestion
                                        ]}
                                    />

                                    <TextField
                                        disabled={disabled}
                                        floatingLabelText="Gewicht (g)"
                                        type="text"
                                        value={
                                            state.weightInput
                                        }
                                        underlineDisabledStyle={{display: 'none'}}
                                        inputStyle={{color: 'black'}}
                                        floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                        floatingLabelShrinkStyle={{color: 'black'}}
                                        fullWidth={true}
                                        errorText={errorMessage(state.weightValidation)}
                                        onChange={(event, value) => {
                                            dispatch({
                                                type: 'ProductCalculationWeightChanged',
                                                value
                                            })
                                        }}
                                    />
                                    <div style={{clear: 'both'}}/>

                                    <SelectField
                                        disabled={disabled}
                                        floatingLabelText="Produkt Versand Dienstleister"
                                        value={state.selectedShippingService}
                                        onChange={(event, index, value) => {
                                            dispatch({
                                                type: 'ProductCalculationShippingServiceChanged',
                                                value
                                            })
                                        }}
                                        floatingLabelStyle={(disabled) ? {color: 'black'} : {}}
                                        underlineDisabledStyle={{display: 'none'}}
                                        fullWidth={true}
                                    >
                                        {indexedMap(
                                            (index, shippingService) =>
                                                <MenuItem
                                                    key={shippingService.id}
                                                    value={shippingService.id}
                                                    primaryText={shippingService.longName}
                                                />,
                                            state.content.availableShippingServices
                                        )}
                                    </SelectField>
                                    <SelectField
                                        disabled={disabled}
                                        multiple={true}
                                        floatingLabelText="Zugewiesene Kunden"
                                        floatingLabelStyle={(disabled) ? {color: 'black'} : {}}
                                        underlineDisabledStyle={{display: 'none'}}
                                        hintText="Kunden auswählen"
                                        value={state.selectedCustomers}
                                        onChange={(event, index, values) => {
                                            dispatch({
                                                type: 'ChangeProductCalculationCustomer',
                                                values: values
                                            })
                                        }}
                                        selectionRenderer={
                                            customerSelectionRendererCarry(state.content.availableCustomers)
                                        }
                                        fullWidth={true}
                                    >
                                        {
                                            R.map(
                                                (customer: Customer) => {
                                                    return (
                                                        <MenuItem
                                                            key={customer.id}
                                                            insetChildren={true}
                                                            checked={R.findIndex(
                                                                (selectedCustomer: number) => {
                                                                    return selectedCustomer === customer.id
                                                                },
                                                                state.selectedCustomers
                                                            ) !== -1}
                                                            value={customer.id}
                                                            primaryText={customer.longName}
                                                        />
                                                    )
                                                },
                                                state.content.availableCustomers
                                            )
                                        }
                                    </SelectField>

                                </Card>
                            </div>

                            <div className="column">
                                <Card
                                    className="tab__form-card"
                                >
                                    {!disabled &&
                                    <div style={{float: 'right'}}>
                                        <FloatingActionButton
                                            mini={true}
                                            onTouchTap={() => dispatch({
                                                type: 'CreatePriceDefinitionPositionRow',
                                            })}
                                        >
                                            <Add/>
                                        </FloatingActionButton>
                                    </div>
                                    }

                                    <h4>Preisliste</h4>

                                    <Table>
                                        <TableHeader
                                            displaySelectAll={false}
                                            adjustForCheckbox={false}
                                        >
                                            <TableRow>
                                                <TableHeaderColumn style={{width: '85px'}}>
                                                    Auflage
                                                </TableHeaderColumn>
                                                <TableHeaderColumn style={{textAlign: 'right'}}>
                                                    Preis pro Stück
                                                </TableHeaderColumn>
                                                {disabled &&
                                                <TableHeaderColumn
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Gesamtpreis der Auflage
                                                </TableHeaderColumn>
                                                }
                                                {!disabled &&
                                                <TableHeaderColumn
                                                    style={{
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Optionen
                                                </TableHeaderColumn>
                                                }
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody displayRowCheckbox={false}>
                                            {
                                                R.map(
                                                    (editablePriceDefinitionRow: EditablePriceDefinitionRow) =>
                                                        <PriceDefinitionRow
                                                            key={editablePriceDefinitionRow.origin.id}
                                                            editablePriceDefinitionRow={editablePriceDefinitionRow}
                                                            disabled={disabled}
                                                            dispatch={dispatch}
                                                        />,
                                                    state.priceDefinitionList
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    )

function PriceDefinitionRow({
                                editablePriceDefinitionRow,
                                disabled,
                                dispatch
                            }: {
    editablePriceDefinitionRow: EditablePriceDefinitionRow,
    disabled: boolean,
    dispatch: (action: ProductCalculationDetailsAction) => void
}) {
    let style = {}
    if (editablePriceDefinitionRow.deleted) {
        style = {
            ...style,
            backgroundColor: 'rgba(0,0,0,0.1)'
        }
    }
    return (
        <TableRow style={style}>
            <TableRowColumn style={{width: '85px'}}>
                <TextField
                    disabled={disabled}
                    type="text"
                    value={editablePriceDefinitionRow.input.quantity}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    fullWidth={true}
                    onChange={(event, value) => dispatch({
                        type: 'PriceDefinitionPositionRowQuantityChange',
                        id: editablePriceDefinitionRow.origin.id,
                        value: value
                    })
                    }
                    errorText={errorMessage(editablePriceDefinitionRow.validation.quantity)}
                />
            </TableRowColumn>
            <TableRowColumn style={{textAlign: 'right'}}>
                <TextField
                    disabled={disabled}
                    type="text"
                    value={editablePriceDefinitionRow.input.price}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black', textAlign: 'right'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    fullWidth={true}
                    onChange={(event, value) => dispatch({
                        type: 'PriceDefinitionPositionRowPriceChange',
                        id: editablePriceDefinitionRow.origin.id,
                        value: value
                    })
                    }
                    errorText={errorMessage(editablePriceDefinitionRow.validation.price)}
                />
                <span style={{fontSize: '1.3em'}}>
                    &nbsp;&euro;
                </span>
            </TableRowColumn>
            {disabled &&
            <TableRowColumn style={{textAlign: 'right', width: '120px'}}>
                {formatPrice(
                    editablePriceDefinitionRow.origin.netVariableCosts
                    * editablePriceDefinitionRow.origin.minQuantity
                )} &euro;
            </TableRowColumn>
            }
            {!disabled &&
            <TableRowColumn style={{textAlign: 'center'}}>
                {editablePriceDefinitionRow.deleted &&
                <IconButton
                    touch={true}
                    onTouchTap={() => dispatch({
                        type: 'ToogleEditablePriceDefinitionRow',
                        id: editablePriceDefinitionRow.origin.id
                    })}
                >
                    <Undo/>
                </IconButton>
                }
                {!editablePriceDefinitionRow.deleted &&
                <IconButton
                    touch={true}
                    onTouchTap={() => dispatch({
                        type: 'ToogleEditablePriceDefinitionRow',
                        id: editablePriceDefinitionRow.origin.id
                    })}
                >
                    <Delete/>
                </IconButton>
                }
            </TableRowColumn>
            }
        </TableRow>
    )
}

export function customerSelectionRendererCarry(customers: Customer[]) {
    return (values: number[]) => R.reduce(
        (acc: string, value: number) => {
            if (acc === '') {
                return getCustomerNameById(customers, value)
            }
            return acc + ', ' + getCustomerNameById(customers, value)
        },
        '',
        values
    )
}

function getCustomerNameById(customers: Customer[], id: number) {
    let result = R.find(
        (customer: Customer) => {
            return customer.id === id
        },
        customers
    )
    if (result === undefined) {
        return ''
    }
    return result.longName
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationDetails/ProductCalculationDetailsView.tsx